<template>
    <compare-page v-if="current === 'comparePage'"/>
    <compare-section :current-prod="currentProduct" v-else/>
</template>

<script>
import ComparePage from "./views/comparePage";
import CompareSection from "./views/compareSection";
export default {
    name: 'compareApp',
    components: {
        CompareSection,
        ComparePage
    },
    data() {
        return {
            current: 'comparePage',
            currentProduct: null,
        }
    },
    created() {
        if (window.currentProduct) {
            this.currentProduct = window.currentProduct
            this.current = 'compareSection'
        } else {
            this.current = 'comparePage'
        }
    },
}
</script>

<style lang="css">

</style>
